<template>
  <el-row class="form-table-border">
    <slot></slot>
  </el-row>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'FormTable',

  props: {
    data: Object,
    labelSpan: {
      type: Number,
      default: 12
    },
    contentSpan: {
      type: Number,
      default: 12
    },
    itemSpan: {
      type: Number,
      default: 12
    }
  },

  provide() {
    return {
      formTable: this,
    }
  },

  data() {
    return {

    }
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
.form-table-border {
  border: 1px solid #EBEEF5;
}
</style>


// WEBPACK FOOTER //
// src/components/FormTable/index.vue